// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { ControlMode, WebPageComponent } from "./WebSite.Page.Component";

export class SignatureField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.build();
    this.initialize();

    if (this.mode === ControlMode.edit)
      this.attachHandlers();
  }

  attachHandlers() {
    this.canvas.addEventListener("mousedown", (event) => { this.startDraw(this.getMousePosition(event)); }, false);
    this.canvas.addEventListener("mouseup", (event) => { this.stopDraw(); }, false);
    this.canvas.addEventListener("mousemove", (event) => { this.draw(this.getMousePosition(event)); }, false);

    this.canvas.addEventListener("touchstart", (event) => { this.startDraw(this.getTouchPosition(event)); }, false);
    this.canvas.addEventListener("touchend", (event) => { this.stopDraw(); }, false);
    this.canvas.addEventListener("touchmove", (event) => { this.draw(this.getTouchPosition(event)); }, false);

    this.clearButton.addEventListener("click", (event) => { this.clear(); }, false);

    document.body.addEventListener("touchstart", (event) => { if (event.target === this.canvas) { event.preventDefault(); } }, false);
    document.body.addEventListener("touchmove", (event) => { if (event.target === this.canvas) { event.preventDefault(); } }, false);
    document.body.addEventListener("touchend", (event) => { if (event.target === this.canvas) { event.preventDefault(); } }, false);
  }

  build() {
    this.canvas = document.createElement("canvas");
    this.canvas.height = 200;
    this.canvas.width = 800;

    this.element.appendChild(this.canvas);

    if (this.mode === ControlMode.edit) {
      this.input = document.createElement("input");
      this.input.setAttribute("type", "hidden");
      this.input.setAttribute("name", this.element.dataset.Name);

      this.element.appendChild(this.input);

      this.clearButton = document.createElement("button");
      this.clearButton.setAttribute("type", "button");

      this.element.appendChild(this.clearButton);
    }
  }

  clear() {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.input.value = "";
  }

  draw(position) {
    if (this.isDrawing && this.previousPosition !== null) {
      this.context.beginPath();
      this.context.moveTo(this.previousPosition.x, this.previousPosition.y);
      this.context.lineTo(position.x, position.y);
      this.context.stroke();

      this.previousPosition = position;
      this.input.value = this.canvas.toDataURL().split(';base64,')[1];
    }
  }

  getPosition(x, y) {
    const rectangle = this.canvas.getBoundingClientRect();
    const scaleX = this.canvas.width / this.canvas.clientWidth;
    const scaleY = this.canvas.height / this.canvas.clientHeight;

    return {
      x: scaleX * (x - rectangle.left),
      y: scaleY * (y - rectangle.top)
    };
  }

  getMousePosition(event) {
    return this.getPosition(event.clientX, event.clientY);
  }

  getTouchPosition(event) {
    return this.getPosition(event.touches[0].clientX, event.touches[0].clientY);
  }

  initialize() {
    this.context = this.canvas.getContext("2d");
    this.context.strokeStyle = "#404040";
    this.context.lineWidth = 2;

    if (this.element.dataset.Value.length >= 0) {
      const image = new Image();
      image.addEventListener("load", () => { this.context.drawImage(image, 0, 0); }, false);
      image.src = "data:image/png;base64," + this.element.dataset.Value;
    }

    this.isDrawing = false;
    this.previousPosition = null;
  }

  stopDraw() {
    this.isDrawing = false;
  }

  startDraw(position) {
    this.isDrawing = true;
    this.previousPosition = position;
  }
}

interactivityRegistration.register("Signature", function (element) { return new SignatureField(element); });
